import React from "react";
import { LANGS } from "./translations";
import { useI18n } from "./LanguageContext";
import "./LanguageSwitcher.scss";

export const LanguageSwitcher: React.FC = () => {
  const { lang, setLang, t } = useI18n();

  return (
    <div className="lang-switch" role="group" aria-label={t("nav.language")}>
      {LANGS.map((item) => (
        <button
          key={item.id}
          type="button"
          className={`lang-switch__btn${lang === item.id ? " is-active" : ""}`}
          aria-pressed={lang === item.id}
          aria-label={item.label}
          title={item.label}
          onClick={() => setLang(item.id)}
        >
          {item.native}
        </button>
      ))}
    </div>
  );
};
